<template>
  <div class="onboarding-network-selector">
    <div class="onboarding-networks-grid">
      <div
        v-for="network in networks"
        :key="network.id"
        class="onboarding-network-item"
        :class="{
          selected: isSelected(network.id),
          disabled: network.disabled
        }"
        @click="toggleNetwork(network)"
      >
        <div class="onboarding-network-icon-wrapper">
          <img
            :src="network.icon"
            :alt="network.name"
            class="onboarding-network-icon"
          />
        </div>
        <span class="onboarding-network-name">{{ network.name }}</span>
        <div
          class="onboarding-network-check"
          :class="{ checked: isSelected(network.id) }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NetworkSelector',

  props: {
    value: {
      type: Array,
      default: () => []
    },
    networks: {
      type: Array,
      required: true
    }
  },

  methods: {
    isSelected(networkId) {
      return this.value.includes(networkId)
    },

    toggleNetwork(network) {
      if (network.disabled) return

      const selected = [...this.value]
      const index = selected.indexOf(network.id)

      if (index > -1) {
        selected.splice(index, 1)
      } else {
        selected.push(network.id)
      }

      this.$emit('input', selected)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/vars.scss';
@import '../variables.scss';

.onboarding-network-selector {
  width: 100%;
}

.onboarding-networks-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.onboarding-network-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 12px;
  background-color: white;
  border: 2px solid $border-ui;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(.disabled) {
    border-color: darken($border-ui, 10%);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  &.selected {
    background-color: $bg-ui-selected;
  }

  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

.onboarding-network-icon-wrapper {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.onboarding-network-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.onboarding-network-name {
  font-family: $avenirnext;
  font-size: 16px;
  font-weight: 600;
  color: $secondary-text-color;
  text-align: center;
}

.onboarding-network-check {
  margin-left: auto;
  border: 1px solid $border-ui;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
  background-color: white;

  &::before {
    content: '✓';
    display: none;
    color: white;
    font: bold 14px/1 sans-serif;
    font-weight: 500;
  }

  &.checked {
    background-color: $primary-color;
    border-color: $primary-color;

    &::before {
      display: block;
    }
  }
}

// Responsive
@media (max-width: 1440px) {
  .onboarding-networks-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .onboarding-networks-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .onboarding-network-item {
    padding: 10px 10px;
  }

  .onboarding-network-icon-wrapper {
    width: 40px;
    height: 40px;
  }

  .onboarding-network-icon {
    width: 32px;
    height: 32px;
  }
}
</style>
